
/* eslint-disable @typescript-eslint/no-shadow */
/* eslint-disable react-hooks/exhaustive-deps */
import "./scss/App.scss";
import React, { FC, ReactElement, useEffect } from "react";
import { BrowserRouter as Router, Route, Routes } from "react-router-dom";

import Navigation from "./Components/shared/Navigation";
import Weather from "./Components/Weather";
import Lightning from "./Components/Lightning";
import CctvPage from "./Components/CctvPage";
import Monitor from "./Components/Monitor";
import AllSky from "./Components/AllSky";
import Telemetrics from "./Components/Telemetrics";
import Iss from "./Components/Iss";
import Solar from "./Components/Solar";
import Lunar from "./Components/Lunar";
import ChartsTemplate from "./Components/ChartsTemplate";
import { SettingsContext, settings } from "./hooks/settings-context";
import dataFetch from "./actions/fetchDataActions";
import usePersistedSettings from "./hooks/usePersistedSettings";

const App: FC = (): ReactElement => {
  const [appSettings, setAppSettings] = usePersistedSettings(
    "settings",
    settings
  );

  useEffect(() => {
    console.log("Enviornment:", process.env.REACT_APP_API_ENDPOINT)
    const domain = window.location.href.split("/");
    let apiEndpoint = "";
    switch (window.location.hostname) {
      case "localhost":
        apiEndpoint =
          "https://utah-api.obsmoana.com:9090";
        break;
      case "elsauce.obsmoana.com":
        apiEndpoint = "https://elsauce-api.obsmoana.com:9090";
        break;
      case "sso.obsmoana.com":
        apiEndpoint = "https://sso-api.obsmoana.com:9090";
        break;
      case "ee1.obsmoana.com":
        apiEndpoint = "https://ee1-api.obsmoana.com:9090";
        break;
      case "ee2.obsmoana.com":
        apiEndpoint = "https://ee2-api.obsmoana.com:9090";
        break;
      case "utah.obsmoana.com":
        apiEndpoint = "https://utah-api.obsmoana.com:9090";
        break;
      default:
        apiEndpoint = `https://api.obsmoana.com:9090`;
        break;
    }
    
    dataFetch(`${apiEndpoint}/utils/value-objects`)
      .then((data) => {
        const defaultSettings = data.items.data[0].data;
        const voyagerFeeds = JSON.parse(defaultSettings?.voyager_feeds || []);
        let activeScope = localStorage.getItem("activeScope");

        if (JSON.parse(defaultSettings?.multi_scopes || "false")) {
          const scopeSettings = JSON.parse(defaultSettings?.scopes || "{}");
          const scopeNames = Object.keys(scopeSettings);

          if (!activeScope || !scopeNames.includes(activeScope)) {
            [activeScope] = scopeNames;
          }

          localStorage.setItem("activeScope", activeScope);

          const activeScopeSettings = scopeSettings?.[activeScope];

          setAppSettings({
            default: {
              ...data.items.data[0],
              apiEndpoint,
              data: {
                ...data.items.data[0].data,
                ...activeScopeSettings,
                voyager_feed: activeScope,
              }
            },
          });
        } else {
          if (!activeScope || !voyagerFeeds.includes(activeScope)) {
            [activeScope] = voyagerFeeds;
            localStorage.setItem('activeScope', activeScope || "");
          }

          setAppSettings({
            default: {
              ...data.items.data[0],
              apiEndpoint,
              data: {
                ...data.items.data[0].data,
                voyager_feed: activeScope,
              }
            },
          });
        }
      })
      .catch(() => {
        //
      });

  }, [appSettings.default.name]);

  return (
    <div className="App">
      <SettingsContext.Provider value={appSettings.default}>
        <Router>
          <Navigation />
          <Routes>
            <Route path="/" element={<Monitor />} />
            <Route path="/Telemetrics" element={<Telemetrics />} />
            {/* <Route path="/Observability" /> */}
            <Route path="/lunar" element={<Lunar />} />
            <Route path="/charts" element={<ChartsTemplate />} />
            <Route path="/solar" element={<Solar />} />
            <Route path="/iss" element={<Iss />} />
            <Route path="/allSky" element={<AllSky />} />
            <Route path="/weather" element={<Weather />} />
            <Route path="/lightning" element={<Lightning />} />
            <Route path="/cctv" element={<CctvPage />} />
          </Routes>
        </Router>
      </SettingsContext.Provider>
    </div>
  );
};

export default App;
